import { ThemeName } from '@/types/styles/ThemeName'
import { Theme, ThemeOptions } from '@mui/material';
import { createContext, Dispatch, SetStateAction } from 'react'

export interface IThemeCreationOptions {
    themeOptions?: ThemeOptions;
    beforeThemeCreated?: (themeOptions: ThemeOptions, chosenTheme: ThemeName ) => ThemeOptions;
    afterThemeCreated?: (theme: Theme, chosenTheme: ThemeName ) => Theme;
}

export interface IThemeActionContext {
    setThemeCreationOptions: Dispatch<SetStateAction<IThemeCreationOptions>>
}

export const ThemeActionContext = createContext<IThemeActionContext>({
    setThemeCreationOptions: () => {}
});

export default ThemeActionContext;